import { apiRequest } from './apiClient';

export function testPanelPing() {
  return apiRequest('/api/test-panel/ping', { method: 'GET' });
}

export function testPanelSiparisTamAkis(payload) {
  return apiRequest('/api/test-panel/run/siparis-tam-akis', {
    method: 'POST',
    body: payload || {},
  });
}
